import React from 'react';
import App from './components/App';

function MainApp() {
  return <App />;
}

export default MainApp;



//aplicação principal